var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0001 1C13.6018 1 14.1949 1.04457 14.7726 1.13028L15.6435 3.76853C16.4063 3.98624 17.1314 4.29652 17.8034 4.68737L20.3062 3.48053C21.1925 4.16109 21.9811 4.96337 22.6462 5.86164L21.3948 8.34217C21.7737 9.02102 22.0719 9.75129 22.2759 10.5193L24.8987 11.433C25.0433 12.5421 25.0334 13.6659 24.8696 14.7724L22.2314 15.6432C22.0151 16.3983 21.7065 17.1237 21.3125 17.8032L22.5194 20.306C21.8379 21.1925 21.0365 21.98 20.1382 22.6459L17.6577 21.3945C16.9715 21.7777 16.2402 22.0737 15.4806 22.2757L14.5669 24.8985C13.4578 25.043 12.334 25.0332 11.2275 24.8693L10.3567 22.2311C9.60163 22.0149 8.87616 21.7062 8.19672 21.3122L5.6939 22.5191C4.80739 21.8376 4.01987 21.0362 3.35394 20.138L4.60535 17.6574C4.22309 16.9708 3.92714 16.2396 3.72422 15.4803L1.10141 14.5649C0.957053 13.4564 0.96686 12.3331 1.13055 11.2273L3.76879 10.3564C3.9865 9.59358 4.29678 8.86845 4.68763 8.19646L3.4808 5.69364C4.16228 4.80712 4.96364 4.01961 5.8619 3.35368L8.34243 4.60509C9.02863 4.2219 9.75999 3.9259 10.5195 3.72396L11.435 1.10114C11.9539 1.03362 12.4767 0.999839 13.0001 1Z",
    stroke: "white",
    strokeWidth: 0.933,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9982 18.1421C15.8385 18.1421 18.141 15.8396 18.141 12.9993C18.141 10.159 15.8385 7.85651 12.9982 7.85651C10.158 7.85651 7.85547 10.159 7.85547 12.9993C7.85547 15.8396 10.158 18.1421 12.9982 18.1421Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.78e1f761690e6ead4008933be3c7aa73.svg";
export { ForwardRef as ReactComponent };